import http from '@/api/http';
// 获取数据列表
export function topicList (params) {
  return http.get('api/Topic/detail', params)
}

// 获取专题信息
export function subjectInfo (params) {
  return http.post('api/NewSubject/subjectInfo', params)
}



// WEBPACK FOOTER //
// ./src/api/modules/topic/topic.js